module.exports = "//__CDN_HOST__/2.0.8/img/banner.3d36933d.png";